import { ClientSelect } from '@features/client/components/client-select';
import { ServiceSelect } from '@features/service/components/ServiceSelect';
import { AutomaticReservation } from './components/automatic-reservation';
import { ReservationManualDate } from './components/reservation-manual-date/reservation-manual-date';
import { useVisitForm } from './visit-form.hooks';

export type PreviewVisit = {
  startTime: string;
  endTime: string;
  serviceName?: string;
};

export const VisitForm = () => {
  const { clientId, serviceIds, showManualDatePickers } = useVisitForm();

  return (
    <>
      <ClientSelect clientId={clientId} />
      <ServiceSelect />
      <ReservationManualDate />
      {!showManualDatePickers && <AutomaticReservation serviceIds={serviceIds} />}
    </>
  );
};
